// src/components/shared/constants/videoTaxonomyMirror.js
// Centralized taxonomy definition for video visual categories and vibes.
// Maps to backend vibeRegistry.js keys: categoryId-vibeId
// Used by: VideoGenerationPanel.js

import { TAXONOMY_MIRROR, SMART_AUTO_VIBE } from './taxonomyMirror';

export { SMART_AUTO_VIBE };

// Video taxonomy extends image taxonomy with video-only vibes (e.g. ASMR)
export const VIDEO_TAXONOMY_MIRROR = TAXONOMY_MIRROR.map(category => {
    if (category.id === "authentic") {
        return {
            ...category,
            vibes: [
                ...category.vibes,
                { id: "asmr", label: "ASMR", desc: "Intimate whispering close-up. Calm, gentle, personal delivery." },
            ],
        };
    }
    return category;
});

// Helper to get the default video vibe (Smart Auto)
export const getDefaultVideoVibe = () => SMART_AUTO_VIBE;

// Helper to find vibes for a category
export const getVideoVibesForCategory = (categoryId) => {
    const category = VIDEO_TAXONOMY_MIRROR.find(c => c.id === categoryId);
    return category?.vibes || [];
};
